var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-mine"},[_vm._v("\n  我的\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }